import * as React from "react";
import classNames from "classnames";

interface ITabContentProps {
    isCurrent: boolean;
    className?: string;
    children: React.ReactNode;
}

const TabContent: React.SFC<ITabContentProps> = props => {
    const rootClasses = classNames("tab-content", props.className, {
        "tab-content--isCurrent": props.isCurrent
    });
    return <div className={rootClasses}>{props.children}</div>;
};

export default TabContent;
